import { useMemo } from 'react';

import { useIntl } from 'react-intl';
import { useRouteStationServicesFilterContext } from '../context';

import { STATION_SERVICES_SORTING } from '../constants';

export const useSortingTitle = () => {
  const { formatMessage } = useIntl();
  const { activeStationsServicesSorting } = useRouteStationServicesFilterContext();

  const sortingTitle = useMemo(() => ({
    [STATION_SERVICES_SORTING.default]: formatMessage({ id: 'byDefault' }),
    [STATION_SERVICES_SORTING.hight]: formatMessage({ id: 'priceLowHight' }),
    [STATION_SERVICES_SORTING.low]: formatMessage({ id: 'priceHightLow' }),
  }[activeStationsServicesSorting] || ''), [
    formatMessage,
    activeStationsServicesSorting
  ]);

  return sortingTitle;
};
